export enum PasswordResetState {
  RequestEmail = 0,
  RequestCode = 1,
  RequestNewPassword = 2,
  Finished = 3
}